import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { useSnackbarAlert } from "../../../hooks/useSnackbarAlert";

const DraftOrdersPage = () => {
  const [draftOrders, setDraftOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const snackbar = useSnackbarAlert();
  const navigate = useNavigate();

  useEffect(() => {
    fetchDraftOrders();
  }, []);

  const fetchDraftOrders = async () => {
    try {
      const res = await api.get("/admin/draft-orders");
      setDraftOrders(res.data);
    } catch (err) {
      console.error("Failed to fetch draft orders", err);
      snackbar.error("Failed to load draft orders.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this draft order?"))
      return;

    try {
      await api.delete(`/admin/draft-orders/${id}`);
      snackbar.success("Draft order deleted");
      setDraftOrders((prev) => prev.filter((o) => o._id !== id));
    } catch (err) {
      console.error("Failed to delete draft", err);
      snackbar.error("Failed to delete draft order.");
    }
  };

  const handleResume = (order) => {
    navigate("/admin/manual-orders", { state: { draft: order } });
  };

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Draft Orders
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : draftOrders.length === 0 ? (
        <Typography>No draft orders found.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Customer</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Items</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {draftOrders.map((order) => (
                <TableRow key={order._id}>
                  <TableCell>
                    {order.formData.customer?.firstName}{" "}
                    {order.formData.customer?.lastName}
                  </TableCell>
                  <TableCell>
                    {dayjs(order.formData.meta?.createdAt).format(
                      "MMM D, YYYY h:mm A"
                    )}
                  </TableCell>
                  <TableCell>{order.formData.items?.length || 0}</TableCell>
                  <TableCell>
                    {order.formData.fulfillment?.location || "-"}
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Resume">
                      <IconButton onClick={() => handleResume(order)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton onClick={() => handleDelete(order._id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default DraftOrdersPage;
